import React from 'react'


type State = {
  error: Error | null
}


type Props = React.PropsWithChildren<{}>

export class OAuthPublicErrorBoundary extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error('OAuth public route render error', error, errorInfo)
  }

  render(): React.ReactNode {
    if( this.state.error ){
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 24,
            fontFamily: 'system-ui, sans-serif',
            backgroundColor: '#fff',
            color: '#222',
          }}>
          <div
            style={{
              maxWidth: 640,
              padding: 32,
              border: '1px solid #ddd',
              borderRadius: 8,
            }}>
            <h2 style={{ marginTop: 0 }}>Something went wrong</h2>
            <p>The authorisation page failed to render. Please contact your representative.</p>
            <details style={{ marginTop: 16, fontSize: 13, color: '#555' }}>
              <summary>Technical details</summary>
              <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {String(this.state.error && this.state.error.stack || this.state.error)}
              </pre>
            </details>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
